export const createOrgUnitScope = (name: string) => {
  const all = [name] as const

  return {
    all,
    orgUnit: (orgUnitId: string) => [...all, orgUnitId] as const,
  }
}

export const createCustomerOrgUnitScope = (name: string) => {
  const all = [name] as const
  const customerIdKey = (customerId: string) => [...all, customerId] as const

  return {
    all,
    customerId: customerIdKey,
    orgUnit: (customerId: string, orgUnitId: string) => [...customerIdKey(customerId), orgUnitId] as const,
  }
}
